<div class="header">
  <mat-toolbar class="topbar" [ngClass]="{ 'home-page': homePage() }">
    <!-- --------------------------------------------------------------- -->

    <!-- ---------------------- -->
    <!-- HOME PAGE LOGO -->
    <!-- ---------------------- -->
    @if (homePage()) {
      <div>
        @if (options.theme === "light") {
          <a [routerLink]="'/'" class="d-flex justify-content-center align-items-center">
            <img src="images/logos/dark_Omni_logo.png" width="114px" height="50px" />
          </a>
        }
        @if (options.theme === "dark") {
          <a [routerLink]="'/'">
            <img src="images/logos/light_Omni_logo.png" width="114px" height="50px" />
          </a>
        }
      </div>
    }

    <div class="start-icon-btn-group">
      @if (!homePage()) {
        <!-- Desktop Menu -->
        @if (showToggle()) {
          <button (click)="toggleCollapsed.emit()" class="icon-btn" matTooltip="{{ 'ToggleMenu' | translate }}">
            <i-tabler name="menu-2" class="icon-20"></i-tabler>
          </button>
        }

        <!-- Mobile Menu -->
        @if (!showToggle()) {
          <button (click)="toggleMobileNav.emit()" class="icon-btn" matTooltip="{{ 'ToggleMenu' | translate }}">
            <i-tabler name="menu-2" class="icon-20"></i-tabler>
          </button>
        }
      }

      <!-- --------------------------------------------------------------- -->

      <!-- --------------------------------------------------------------- -->
      <!--  Search -->
      <!-- --------------------------------------------------------------- -->
      <!-- <button mat-icon-button (click)="openDialog()" class="d-flex justify-content-center">
    <i-tabler name="search" class="icon-20 d-flex"></i-tabler>
  </button> -->

      <div class="d-none d-lg-flex">
        <!-- --------------------------------------------------------------- -->
        <!--  Links -->
        <!-- --------------------------------------------------------------- -->
        @if (!homePage()) {
          <button
            [matMenuTriggerFor]="appsmenu"
            aria-label="Apps"
            class="systems-btn"
            matTooltip="{{ 'Systems' | translate }}"
          >
            <i-tabler name="layout-grid" class="icon-20"></i-tabler>
            {{ "Systems" | translate }} <i-tabler name="chevron-down" class="icon-16"></i-tabler>
          </button>
        }

        <mat-menu #appsmenu="matMenu" class="apps-dd cardWithShadow">
          <div class="row">
            <div class="col-sm-12">
              <div class="p-32 p-b-0">
                <div class="row">
                  @for (appdd of apps(); track appdd.title) {
                    <div class="col-sm-6 text-hover-primary">
                      <a [href]="appdd.link" class="d-flex align-items-center text-decoration-none m-b-24">
                        <span class="text-primary rounded icon-40 d-flex align-items-center justify-content-center">
                          <img [src]="appdd.img" width="45" />
                        </span>

                        <div class="m-l-16">
                          <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                            {{ appdd.title }}
                          </h5>
                          <span class="mat-body-1 f-s-12 hover-text">{{ appdd.subtitle }}</span>
                        </div>
                      </a>
                    </div>
                  }
                </div>
              </div>
              <!-- <div class="b-t-1 p-24 d-none d-lg-flex align-items-center justify-content-between">
            <span class="d-flex align-items-center mat-subtitle-1 f-s-16 f-w-500">
              <i-tabler name="help" class="icon-20 m-r-8"></i-tabler>Frequently Asked Questions
            </span>
            <a [routerLink]="['/theme-pages/faq']" mat-flat-button color="primary">Check</a>
          </div> -->
            </div>
            <!-- <div class="col-sm-4">
          <div class="p-x-16 p-y-32">
            <h4 class="f-s-18 f-w-600 mat-subtitle-1 m-b-16">Quick Links</h4>
            @for(quicklink of quicklinks; track quicklink.title) {
            <div class="text-hover-primary">
              <a
                [routerLink]="[quicklink.link]"
                class="hover-text text-decoration-none mat-body-1 f-w-600 d-block p-y-8"
                >{{ quicklink.title }}</a
              >
            </div>
            }
          </div>
        </div> -->
          </div>
        </mat-menu>
      </div>
    </div>

    @if (!homePage()) {
      <button (click)="navigateToHome()" class="icon-btn" matTooltip="{{ 'Home' | translate }}">
        <i-tabler name="home" />
      </button>
    }
    <!-- <div>
      @if(this.renewalMessage()?.Message?.length ??0 >0){
      <div class="d-none d-sm-flex align-content-center bg-error f-s-14 p-x-6 m-y-2 text-white f-w-500 flex-grow-1">
        <span class="text-wrap"
          >{{ this.renewalMessage()?.Message }}

          @if(this.renewalMessage()?.PaymentLink?.length ??0 >0 || true){
          <a mat-flat-button color="primary" [href]="this.renewalMessage()?.PaymentLink" target="_blank">
            {{ "Renew From Here" | translate }}
          </a>
          }
        </span>
      </div>
      } @if(this.visitingCompanyName() != null){
      <div class="d-none d-sm-flex align-content-center bg-error f-s-14 p-x-6 m-y-2 text-white f-w-500">
        <span>{{ "You are now visiting the company system" | translate }}: </span>
        &nbsp;
        <span>[{{ this.visitingCompanyName() }}]</span>
      </div>
      }
    </div> -->

    <span class="flex-1-auto"></span>

    <!-- Mobile Menu -->
    <button (click)="toggleMobileFilterNav.emit()" class="icon-btn d-lg-none" matTooltip="{{ 'Systems' | translate }}">
      <i-tabler name="grid-dots" class="icon-20"></i-tabler>
    </button>
    @if (this.showFinancialYearsDropdown()) {
      <!-- --------------------------------------------------------------- -->
      <!-- Financial Year Dropdown -->
      <!-- --------------------------------------------------------------- -->
      <button
        [matMenuTriggerFor]="flags"
        class="f-s-16 f-w-600"
        mat-button
        style="min-width: 50px"
        matTooltip="{{ 'CurrentFinancialYear' | translate }}"
      >
        {{ this.financialYearService.FinancialYear()?.Title }}
      </button>
      <mat-menu #flags="matMenu" class="cardWithShadow">
        @for (year of this.financialYearService.financialYearsList(); track year.FinancailYearID) {
          <button mat-menu-item (click)="changeFinancialYear(year)">
            <div>
              <span class="mat-subtitle-1 f-s-14">{{ year.Title }}</span>
            </div>
          </button>
        }
      </mat-menu>
    }
    <div class="icon-btn-group">
      @if (accountSetup(); as setup) {
        @if (setup.enabled) {
          <!-- --------------------------------------------------------------- -->
          <!-- Account setup: always reachable; the badge counts steps still to do or skipped -->
          <!-- --------------------------------------------------------------- -->
          <a
            [href]="accountSetupUrl"
            class="icon-btn"
            [attr.aria-label]="(setup.remaining ? 'AccountSetupRemaining' : 'AccountSetup') | translate: { count: setup.remaining }"
            matTooltip="{{ (setup.remaining ? 'AccountSetupRemaining' : 'AccountSetup') | translate: { count: setup.remaining } }}"
          >
            <i-tabler
              class="d-flex"
              name="rocket"
              [matBadge]="setup.remaining"
              [matBadgeHidden]="!setup.remaining"
              matBadgeColor="warn"
              matBadgeSize="small"
            />
          </a>
        }
      }
      @if (showAskButton()) {
        <!-- --------------------------------------------------------------- -->
        <!-- Help & support panel (related articles, Ask AI, technical support) -->
        <!-- --------------------------------------------------------------- -->
        <button
          (click)="toggleAskPanel.emit()"
          class="icon-btn icon-btn--ai"
          [attr.aria-label]="'HelpAndSupport' | translate"
          matTooltip="{{ 'HelpAndSupport' | translate }}"
        >
          <svg class="ai-sparkle" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 1 Q13.2 10.8 23 12 Q13.2 13.2 12 23 Q10.8 13.2 1 12 Q10.8 10.8 12 1 Z" />
          </svg>
        </button>
      }
      <a routerLink="/SystemReports" [target]="systemReportsTarget" class="icon-btn" matTooltip="{{ 'SystemReports' | translate }}">
        <i-tabler name="report" />
      </a>
      <button (click)="SetTheme(options.theme)" class="icon-btn" matTooltip="{{ 'Theme' | translate }}">
        <i-tabler [name]="options.theme === 'dark' ? 'sun-high' : 'moon'" />
      </button>

      <!-- --------------------------------------------------------------- -->
      <!-- Notification Dropdown -->
      <!-- --------------------------------------------------------------- -->
      <button
        [matMenuTriggerFor]="notificationMenu"
        aria-label="Notifications"
        class="icon-btn"
        matTooltip="{{ 'Notifications' | translate }}"
      >
        <!-- matBadge will be used for the count -->
        <i-tabler class="d-flex" name="bell" matBadge="" matBadgeColor="primary" />
      </button>
      <mat-menu #notificationMenu="matMenu" class="topbar-dd cardWithShadow">
        <div class="d-flex align-items-center p-x-32 p-y-16">
          <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">{{ "Notifications" | translate }}</h6>
          <span class="m-l-auto">
            <!-- <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">5 new</span> -->
          </span>
        </div>

        <div class="p-x-10">
          @for (notification of notifications(); track notification.NotificationID) {
            <mat-card class="m-y-4">
              <mat-card-content>
                <div class="d-flex justify-content-between">
                  <mat-chip>{{ notification.NotificationTypeTitle }}</mat-chip>
                  <span class="ml-2 text-sm text-gray-500">{{ notification.AddedDate | date }}</span>
                </div>
                <p class="mt-2">{{ notification.NotificationText }}</p>
              </mat-card-content>
            </mat-card>
          }
        </div>

        <div class="p-y-12 p-x-32">
          <button mat-stroked-button routerLink="/SystemNotifications" color="primary" class="w-100">
            {{ "See all notifications" | translate }}
          </button>
        </div>
      </mat-menu>

      <!-- --------------------------------------------------------------- -->
      <!-- langugage Dropdown -->
      <!-- --------------------------------------------------------------- -->
      <button [matMenuTriggerFor]="flags" class="icon-btn" matTooltip="{{ 'Language' | translate }}">
        <img [src]="selectedLanguage.icon" class="rounded-circle object-cover" />
      </button>
      <mat-menu #flags="matMenu" class="cardWithShadow">
        @for (lang of languages; track lang.code) {
          <button mat-menu-item (click)="changeLanguage(lang)">
            <div class="d-flex align-items-center">
              <img [src]="lang.icon" class="rounded-circle object-cover m-r-8 icon-20 lng" />
              <span class="mat-subtitle-1 f-s-14">{{ lang.language }}</span>
            </div>
          </button>
        }
      </mat-menu>

      <mat-divider vertical style="margin: 0 12px"></mat-divider>

      <!-- --------------------------------------------------------------- -->
      <!-- profile Dropdown -->
      <!-- --------------------------------------------------------------- -->
      <button
        [matMenuTriggerFor]="profilemenu"
        aria-label="Profile"
        class="profile-btn"
        matTooltip="{{ 'ProfileMenu' | translate }}"
      >
        <i-tabler name="user" class="icon-22" />
        <b>{{ userData().userData?.username }}</b>
        <i-tabler name="chevron-down" class="icon-16" />
        <!-- <img src="assets/images/profile/user-1.jpg" class="rounded-circle object-cover icon-35 profile-dd" width="35" /> -->
      </button>
      <mat-menu #profilemenu="matMenu" class="cardWithShadow profile-card">
        <ng-scrollbar class="position-relative">
          <!-- <div class="p-x-32 p-y-8"> -->
          <!-- <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">{{ "My Profile" | translate }}</h6> -->

          <div class="d-flex align-items-center b-b-1 p-16">
            <span class="align-items-center">
              <b class="username-color">{{ userData().userData?.username }}</b>
              <i-tabler name="user" class="icon-15 m-r-4"></i-tabler>
            </span>
          </div>
          <!-- </div> -->
          <!-- <div class="p-x-32">
          @for(profile of profiledd; track profile.title) {
          <a class="text-decoration-none d-block text-hover-primary" [href]="profile.link">
            <div class="d-flex align-items-center">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <img [src]="profile.img" width="20" />
              </button>

              <div class="m-l-16">
                <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                  {{ profile.title | translate }}
                </h5>
                <span class="mat-body-1">{{ profile.subtitle | translate }}</span>
              </div>
            </div>
          </a>
          }
        </div> -->
          <div class="p-t-12">
            <a [href]="'/settings/MyAccount'" mat-stroked-button color="primary" class="w-100 profile-item">
              <span class="profile-text">{{ "My Account" | translate }}</span>
              <i-tabler name="settings" class="icon-18 m-r-4"></i-tabler>
            </a>
          </div>
          <div class="p-t-12">
            <a (click)="logout()" mat-stroked-button color="warn" class="w-100 profile-item">
              <span class="profile-text">{{ "Logout" | translate }}</span>
              <i-tabler name="logout" class="icon-18 m-r-4"></i-tabler>
            </a>
          </div>
        </ng-scrollbar>
      </mat-menu>
    </div>
  </mat-toolbar>
  <!-- 
  RENEW MSG -->
  @if (this.renewalMessage()?.Message?.length ?? 0 > 0) {
    <div class="info-box">
      <p>
        {{ this.renewalMessage()?.Message }}
      </p>
      @if ((this.renewalMessage()?.PaymentLink?.length ?? 0 > 0) || true) {
        <a [href]="this.renewalMessage()?.PaymentLink" target="_blank" class="renewal-btn">
          {{ "RenewButton" | translate }}
        </a>
      }
    </div>
  }
  @if (this.visitingCompanyName() != null) {
    <div class="info-box">
      <p>{{ "You are now visiting the company system" | translate }}: [{{ this.visitingCompanyName() }}]</p>
    </div>
  }
</div>

<!-- @if(this.renewalMessage()?.Message?.length ??0 >0){
<div class="visit-company-div align-content-center bg-error f-s-14 p-x-6 m-y-2 text-white f-w-500 flex-grow-1">
  <span class="text-wrap"
    >{{ this.renewalMessage()?.Message }}

    @if(this.renewalMessage()?.PaymentLink?.length ??0 >0 || true){
    <a mat-flat-button color="primary" [href]="this.renewalMessage()?.PaymentLink" target="_blank">
      {{ "Renew From Here" | translate }}
    </a>
    }
  </span>
</div>
} @if(this.visitingCompanyName() != null){
<div class="visit-company-div align-content-center bg-error f-s-14 p-x-6 m-y-2 text-white f-w-500">
  <span>{{ "You are now visiting the company system" | translate }}: </span>
  <span>[{{ this.visitingCompanyName() }}]</span>
</div>
} -->
